import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../firebase/auth.tsx";
import { useTranslation } from "react-i18next";
import { correctUserRoleName } from "./helpers/helpers.tsx";
import CreateTrainingPlanModal from "./modals/createTrainingPlanModal.tsx";
import "../styles/admin.css";

const HeadsetManagerMenu = ({ updateTrainingPlanList }) => {
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [showCreatePlanModal, setShowCreatePlanModal] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  
  const navigate = useNavigate();
  const location = useLocation();
  const { userRole } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOptionsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleDropdown = () => {
    setIsOptionsOpen(!isOptionsOpen);
  };

  const handleCreatePlanClick = () => {
    setShowCreatePlanModal(true);
  };

  const handleCreatePlan = (newPlan) => {
    if (updateTrainingPlanList) updateTrainingPlanList(newPlan);
    setShowCreatePlanModal(false);
  };

  return (
    <>
      <div
        style={{
          backgroundColor: "#D4E5E2",
          borderRadius: "10px",
          marginTop: "86px",
          marginLeft: "50px",
          marginRight: "50px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "70px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src="/images/Icon_HQ.png" 
            alt="Logo"
            style={{
              width: "6vh",
              minWidth: "50px",
              marginLeft: "20px",
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginLeft: "20px",
              color: "white",
              lineHeight: "1",
            }}
          >
            <div
              style={{
                textAlign: "left",
                paddingBottom: "8px",
                color: "#39a686",
                fontSize: "1.3em",
              }}
            >
              <strong>{t("Headsets")}</strong>
            </div>
            <div
              style={{
                textAlign: "left",
                fontFamily: "VirtualLabQuickSandBold",
                color: "#212529",
                fontSize: "1.1em",
              }}
            >
              {t("Your_role")}:{" "}
              <span style={{ fontFamily: "VirtualLabQuickSandMedium" }}>
                  {correctUserRoleName(userRole, t)}
              </span>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            marginRight: "20px",
          }}
        >
          {location.pathname.includes("my-training-plans") && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleCreatePlanClick}
              style={{
                backgroundColor: "#39A686",
                borderColor: "#39A686",
                borderRadius: "10px",
                fontSize: "1.2em",
                marginRight: "10px",
              }}
            >
              {t("Add_new_training_plan")}
            </button>
          )}
        </div>
      </div>
      
      {showCreatePlanModal && (
        <div className={"adminContainer"}>
            <CreateTrainingPlanModal
            setShowCreatePlanModal={setShowCreatePlanModal}
            handleCreatePlan={handleCreatePlan}
            headquarterId={null} 
            />
        </div>
      )}
    </>
  );
};

export default HeadsetManagerMenu;